import { FeaturePage } from '@/modules/support/components/feature/page';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(FeaturePage);

export const roles: string[] = ['super-admin', 'supporter'];
export const path = '/support/feature';
export const element = <AnimatedPage />